import type { JobInterruption } from '../../../services/adminUnits';
import { formatMoment } from './unitsFormat';

function ReasonChip({ interruption }: { interruption: JobInterruption }) {
  return interruption.reason === 'LastAttempt' ? (
    <span className="chip danger"><span className="dot" />Failed on its last attempt</span>
  ) : (
    <span className="chip warn"><span className="dot" />Back in the queue</span>
  );
}

function InterruptionCard({ interruption }: { interruption: JobInterruption }) {
  return (
    <div className="card" role="listitem" style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontWeight: 600, fontSize: 13.5 }}>{formatMoment(interruption.interruptedAt)}</span>
        <ReasonChip interruption={interruption} />
        {interruption.emergencyCommitSaved ? (
          <span className="chip ok"><span className="dot" />Emergency commit saved</span>
        ) : (
          <span className="chip"><span className="dot" />No emergency commit</span>
        )}
      </div>
      <div style={{ fontSize: 13 }}>
        {interruption.projectName ?? 'A project that no longer exists'}
        <span className="muted"> · {interruption.userEmail ?? 'a user who no longer exists'}</span>
        <span className="mono muted" style={{ fontSize: 12, marginLeft: 8 }}>job {interruption.jobId}</span>
      </div>
      <div className="muted" style={{ fontSize: 12.5 }}>
        Unit <span className="mono">{interruption.workerId}</span> · attempt {interruption.attemptNumber} ·{' '}
        {interruption.minutesLost.toFixed(1)} min lost · {interruption.creditsRefunded} credits and{' '}
        {interruption.imagesRefunded} images refunded
      </div>
    </div>
  );
}

export default function InterruptionsList({ interruptions }: { interruptions: JobInterruption[] }) {
  if (interruptions.length === 0) {
    return (
      <div className="card quiet" style={{ padding: 20 }}>
        <span className="muted">No job was interrupted.</span>
      </div>
    );
  }
  return (
    <div role="list" aria-label="Interruptions" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {interruptions.map((interruption) => (
        <InterruptionCard key={interruption.id} interruption={interruption} />
      ))}
    </div>
  );
}
